// app/frontend/src/main.tsx
import "@app/index.css";
import { captureAttribution } from "@app/pages/onboarding/attribution";
import { environment } from "@app/relay/relay-environment";
import { routeTree } from "@app/routeTree.gen";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import React from "react";
import ReactDOM from "react-dom/client";

// 1. Add these imports
import { RelayEnvironmentProvider } from "react-relay";

// Ahead of the router, which can rewrite the address the visitor arrived at.
captureAttribution();

const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const rootElement = document.getElementById("root")!;

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    {/* 2. Wrap your RouterProvider */}
    <RelayEnvironmentProvider environment={environment}>
      <RouterProvider router={router} />
    </RelayEnvironmentProvider>
  </React.StrictMode>
);
